import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import AttedanceReport from "../../../components/Faculty/AttendanceReport";

const AttendanceReportPage = (props) => {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={12} sm={10} style={{ margin: "0 auto" }}>
          <AttedanceReport />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default AttendanceReportPage;
